import { createThunklessAction } from 'thunkless';

import { avo } from '@/api/app/avo-client';

export enum WhatsappTypes {
  FETCH_SENDERS_REQUEST = 'app/whatsapp/FETCH_SENDERS_REQUEST',
  FETCH_SENDERS_SUCCESS = 'app/whatsapp/FETCH_SENDERS_SUCCESS',
  FETCH_SENDERS_FAILURE = 'app/whatsapp/FETCH_SENDERS_FAILURE',

  CREATE_SENDER_REQUEST = 'app/whatsapp/CREATE_SENDER_REQUEST',
  CREATE_SENDER_SUCCESS = 'app/whatsapp/CREATE_SENDER_SUCCESS',
  CREATE_SENDER_FAILURE = 'app/whatsapp/CREATE_SENDER_FAILURE',

  REGISTER_SENDER_REQUEST = 'app/whatsapp/REGISTER_SENDER_REQUEST',
  REGISTER_SENDER_SUCCESS = 'app/whatsapp/REGISTER_SENDER_SUCCESS',
  REGISTER_SENDER_FAILURE = 'app/whatsapp/REGISTER_SENDER_FAILURE',

  FETCH_SENDER_REQUEST = 'app/whatsapp/FETCH_SENDER_REQUEST',
  FETCH_SENDER_SUCCESS = 'app/whatsapp/FETCH_SENDER_SUCCESS',
  FETCH_SENDER_FAILURE = 'app/whatsapp/FETCH_SENDER_FAILURE',

  VERIFY_SENDER_REQUEST = 'app/whatsapp/VERIFY_SENDER_REQUEST',
  VERIFY_SENDER_SUCCESS = 'app/whatsapp/VERIFY_SENDER_SUCCESS',
  VERIFY_SENDER_FAILURE = 'app/whatsapp/VERIFY_SENDER_FAILURE',

  DESTROY_SENDER_REQUEST = 'app/whatsapp/DESTROY_SENDER_REQUEST',
  DESTROY_SENDER_SUCCESS = 'app/whatsapp/DESTROY_SENDER_SUCCESS',
  DESTROY_SENDER_FAILURE = 'app/whatsapp/DESTROY_SENDER_FAILURE',

  SET_CONNECT_ERROR = 'app/whatsapp/SET_CONNECT_ERROR',
}

export const setWhatsappConnectError = (message: string | null) => ({
  type: WhatsappTypes.SET_CONNECT_ERROR as const,
  payload: { message },
});

export const fetchWhatsappSenders = ({ subdomain }: { subdomain: string }) => createThunklessAction({
  type: [
    WhatsappTypes.FETCH_SENDERS_REQUEST,
    WhatsappTypes.FETCH_SENDERS_SUCCESS,
    WhatsappTypes.FETCH_SENDERS_FAILURE,
  ] as const,
  promise: () => avo.ajax({ route: '/v1/whatsapp_senders', params: { subdomain } }),
});

export interface CreateWhatsappSenderProps {
  subdomain: string;
  phoneNumber: string;
  displayName: string;
  verificationMethod: 'sms' | 'voice' | null;
}

export const createWhatsappSender = ({
  subdomain, phoneNumber, displayName, verificationMethod,
}: CreateWhatsappSenderProps) => createThunklessAction({
  type: [
    WhatsappTypes.CREATE_SENDER_REQUEST,
    WhatsappTypes.CREATE_SENDER_SUCCESS,
    WhatsappTypes.CREATE_SENDER_FAILURE,
  ] as const,
  promise: () => avo.ajax({
    method: 'POST',
    route: '/v1/whatsapp_senders',
    payload: {
      subdomain,
      phone_number: phoneNumber,
      display_name: displayName,
      verification_method: verificationMethod ?? '',
    },
  }, { retries: 0 }),
});

export interface RegisterWhatsappSenderProps {
  subdomain: string;
  id: number;
  wabaId: string;
  metaPhoneNumberId: string | null;
}

export const registerWhatsappSender = ({
  subdomain, id, wabaId, metaPhoneNumberId,
}: RegisterWhatsappSenderProps) => createThunklessAction({
  type: [
    WhatsappTypes.REGISTER_SENDER_REQUEST,
    WhatsappTypes.REGISTER_SENDER_SUCCESS,
    WhatsappTypes.REGISTER_SENDER_FAILURE,
  ] as const,
  promise: () => avo.ajax({
    method: 'POST',
    route: `/v1/whatsapp_senders/${id}/register`,
    payload: { subdomain, waba_id: wabaId, meta_phone_number_id: metaPhoneNumberId ?? '' },
  }, { retries: 0 }),
  meta: { id },
});

export const fetchWhatsappSender = ({ subdomain, id }: { subdomain: string; id: number }) => createThunklessAction({
  type: [
    WhatsappTypes.FETCH_SENDER_REQUEST,
    WhatsappTypes.FETCH_SENDER_SUCCESS,
    WhatsappTypes.FETCH_SENDER_FAILURE,
  ] as const,
  promise: () => avo.ajax({ route: `/v1/whatsapp_senders/${id}`, params: { subdomain } }),
  meta: { id },
});

export const verifyWhatsappSender = ({
  subdomain, id, code,
}: { subdomain: string; id: number; code: string }) => createThunklessAction({
  type: [
    WhatsappTypes.VERIFY_SENDER_REQUEST,
    WhatsappTypes.VERIFY_SENDER_SUCCESS,
    WhatsappTypes.VERIFY_SENDER_FAILURE,
  ] as const,
  promise: () => avo.ajax({
    method: 'POST',
    route: `/v1/whatsapp_senders/${id}/verify`,
    payload: { subdomain, code },
  }, { retries: 0 }),
  meta: { id },
});

export const destroyWhatsappSender = ({ subdomain, id }: { subdomain: string; id: number }) => createThunklessAction({
  type: [
    WhatsappTypes.DESTROY_SENDER_REQUEST,
    WhatsappTypes.DESTROY_SENDER_SUCCESS,
    WhatsappTypes.DESTROY_SENDER_FAILURE,
  ] as const,
  promise: () => avo.ajax({
    method: 'DELETE',
    route: `/v1/whatsapp_senders/${id}`,
    payload: { subdomain },
  }, { retries: 0 }),
  meta: { id },
});
